/** Target capacity ~5,000 words; character cap (~10 chars/word incl. spaces) for long clinical text. */
export const NOTE_FIELD_MAX_CHARS = 50000;

export function countWords(text) {
  const s = String(text ?? "").trim();
  if (!s) return 0;
  return s.split(/\s+/).filter(Boolean).length;
}

export const noteFieldShowCount = {
  formatter: ({ value = "" }) => {
    const w = countWords(String(value));
    return `${w.toLocaleString()} / 5,000 words`;
  },
};
